"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return WorkspaceUser;
    }
});
let WorkspaceUser = class WorkspaceUser {
    static async insert(..._args) {}
    static async get(..._args) {
        return null;
    }
    static async workspaceList(..._args) {
        return [];
    }
    static async userList(..._args) {
        return [];
    }
    static async count(..._args) {
        return 0;
    }
    static async update(..._args) {
        return null;
    }
    static async softDelete(..._args) {
        return null;
    }
    static async delete(..._args) {
        return null;
    }
    static async clearCache(..._args) {}
    static async getByToken(..._args) {
        return null;
    }
    constructor(data){
        Object.assign(this, data);
    }
};
